<div class="tt-data-table" data-guide="main-table">

  <div class="tt-data-table__chrome">

    <div class="tt-data-table__toolbar">

      <p *ngIf="showToolbarSummary" class="tt-data-table__summary">{{ summaryText }}</p>

      <!-- Parked on the page-header subtitle row when a header slot is registered. -->
      <div class="tt-data-table__toolbar-actions" #toolbarActions>

        <div class="tt-data-table__filters">

          <ng-content select="[dataTableFilters]"></ng-content>

        </div>

        <button
          *ngIf="enableExport"
          type="button"
          class="tt-filter-icon-btn tt-data-table__export"
          data-guide="list-export"
          aria-label="Exportovat"
          title="Exportovat"
          [disabled]="exportButtonDisabled"
          [attr.aria-busy]="exportBusy || exporting ? true : null"
          (click)="onExportClick()"
        >
          <app-action-icon name="export"></app-action-icon>
        </button>

      </div>

    </div>

    <app-table-pagination
      *ngIf="showPaginationBar"
      data-guide="list-pages"
      layout="bar"
      [ngClass]="paginationWrapperClass"
      [currentPage]="currentPage"
      [totalItems]="effectiveTotalItems"
      [itemsPerPage]="itemsPerPage"
      [showAllAction]="showAllActionEnabled"
      [showAllActive]="showAllRowsActive"
      [showAllLoading]="showAllLoading"
      (pageChange)="pageChange.emit($event)"
      (showAllClick)="showAll.emit()"
      (exitShowAllClick)="exitShowAll.emit()"
    ></app-table-pagination>

  </div>



  <app-skeleton

    *ngIf="loading"

    variant="table"

    [columns]="skeletonColumnCount"

    [rows]="skeletonRowCount"

    [label]="loadingMessage"

  ></app-skeleton>



  <app-error-state

    *ngIf="!loading && errorMessage"

    [message]="errorMessage"

    (retry)="retry.emit()"

  ></app-error-state>



  <div *ngIf="!loading && !errorMessage" class="tt-table-enter">

    <app-empty-state
      *ngIf="showEmptySource"
      [title]="emptyTitle"
      [message]="emptyMessage"
    ></app-empty-state>



    <div

      *ngIf="showEmptyFiltered"

      class="tt-surface tt-surface--padded text-center text-sm text-neutral-500 dark:text-neutral-400"

    >

      {{ emptyFilteredMessage }}

    </div>



    <ng-content select="[dataTableBeforeTable]"></ng-content>

    <div *ngIf="showTableBlock" [class]="tableWrapperClass()">

      <div #tableScroll class="tt-data-table__scroll" [class.tt-data-table__scroll--x]="horizontalScroll">

        <table
          [class]="resolvedTableClass()"
          [style.min-width]="resolvedTableMinWidth()"
          [style.width]="resolvedTableWidth()"
        >

          <colgroup *ngIf="layout !== 'fluid' || hasManualColumnWidths">
            <col *ngFor="let width of columnTrackWidths(); trackBy: trackColumnIndex" [style.width]="width" />
          </colgroup>

          <thead [class]="theadClass">

            <tr>

              <th

                *ngFor="let col of columns; trackBy: trackColumn; let colIndex = index"

                [class]="thClass(col)"

                [style.width.px]="manualColumnWidthPx(col)"

                [style.min-width.px]="manualColumnWidthPx(col)"

                [style.max-width.px]="manualColumnWidthPx(col)"

                [attr.data-col-id]="col.id"

                [attr.title]="col.headerTitle || null"

                [attr.aria-sort]="isColumnSortable(col) ? (activeSortBy === col.id ? (activeSortOrder === 'asc' ? 'ascending' : 'descending') : 'none') : null"

              >

                <div class="tt-data-table__th-inner">

                  <button

                    *ngIf="isColumnSortable(col); else headerLabelOnly"

                    type="button"

                    class="tt-data-table__sort-btn inline-flex items-center gap-1 min-w-0 max-w-full bg-transparent border-0 p-0 m-0 cursor-pointer text-inherit uppercase rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-1"

                    [attr.aria-label]="sortButtonAriaLabel(col)"

                    (click)="onHeaderClick(col)"

                  >

                    <ng-container *ngTemplateOutlet="headerLabelOnly"></ng-container>

                    <svg

                      *ngIf="activeSortBy === col.id"

                      class="w-3.5 h-3.5 inline shrink-0"

                      fill="none"

                      stroke="currentColor"

                      viewBox="0 0 24 24"

                      aria-hidden="true"

                    >

                      <path

                        *ngIf="activeSortOrder === 'asc'"

                        stroke-linecap="round"

                        stroke-linejoin="round"

                        stroke-width="2"

                        d="M5 15l7-7 7 7"

                      ></path>

                      <path

                        *ngIf="activeSortOrder === 'desc'"

                        stroke-linecap="round"

                        stroke-linejoin="round"

                        stroke-width="2"

                        d="M19 9l-7 7-7-7"

                      ></path>

                    </svg>

                    <svg

                      *ngIf="activeSortBy !== col.id"

                      class="w-3.5 h-3.5 inline shrink-0 opacity-30"

                      fill="none"

                      stroke="currentColor"

                      viewBox="0 0 24 24"

                      aria-hidden="true"

                    >

                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4"></path>

                    </svg>

                  </button>

                  <ng-template #headerLabelOnly>

                    <ng-container *ngIf="col.headerCell === 'template' && headerTemplate(col.id); else defaultHeader">

                      <ng-container

                        *ngTemplateOutlet="headerTemplate(col.id)!.templateRef"

                      ></ng-container>

                    </ng-container>

                    <ng-template #defaultHeader><span class="tt-data-table__th-label" [attr.title]="headerLabelTitle(col)">{{ col.label }}</span></ng-template>

                  </ng-template>

                  <button

                    *ngIf="isColumnFilterable(col)"

                    type="button"

                    class="tt-data-table__col-filter-btn"

                    [class.tt-data-table__col-filter-btn--active]="isColumnFilterActive(col) || openFilterColumnId === col.id"

                    [attr.aria-label]="filterButtonAriaLabel(col)"

                    [attr.title]="filterButtonAriaLabel(col)"

                    [attr.aria-expanded]="openFilterColumnId === col.id"

                    [attr.aria-haspopup]="'dialog'"

                    (click)="toggleColumnFilter(col, $event)"

                  >

                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">

                      <path

                        stroke-linecap="round"

                        stroke-linejoin="round"

                        stroke-width="2"

                        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"

                      ></path>

                    </svg>

                    <span

                      *ngIf="isColumnFilterActive(col)"

                      class="tt-data-table__col-filter-btn__badge"

                      aria-hidden="true"

                    ></span>

                  </button>

                </div>

                <span
                  *ngIf="isColumnResizable(col)"
                  class="tt-col-resizer"
                  [class.tt-col-resizer--active]="resizingColumnId === col.id"
                  [class.tt-col-resizer--customized]="isColumnManuallySized(col)"
                  role="separator"
                  aria-orientation="vertical"
                  [attr.aria-label]="'Změnit šířku sloupce ' + (col.label || col.id)"
                  title="Tažením změníte šířku sloupce, dvojklikem obnovíte výchozí"
                  (mousedown)="onColumnResizeStart($event, col, colIndex)"
                  (click)="$event.stopPropagation(); $event.preventDefault()"
                  (dblclick)="onColumnResizeReset($event, col)"
                ></span>

              </th>

            </tr>

          </thead>

          <tbody>

            <tr *ngIf="showColumnFilterEmpty" class="tt-data-table__filter-empty-row">
              <td
                [attr.colspan]="columns.length"
                class="px-6 py-8 text-center text-sm text-neutral-500 dark:text-neutral-400"
              >
                {{ emptyFilteredMessage }}
              </td>
            </tr>

            <ng-container *ngFor="let row of displayRows; trackBy: trackRow; let i = index">

              <tr

                [class]="rowClasses(row)"

                [class.tt-table-row-enter]="rowStaggerArmed"

                [style.animation-delay]="rowStaggerArmed ? rowEnterDelay(i) : null"

                [attr.data-list-row-id]="rowDomIdAttr(row)"

                [attr.role]="isRowClickable(row) ? 'button' : null"

                [attr.tabindex]="isRowClickable(row) ? 0 : null"

                [attr.aria-label]="rowAriaLabel(row)"

                [attr.aria-expanded]="isRowExpanded(row) ? true : null"

                (click)="onRowClick($event, row)"

                (dblclick)="onRowDblClick($event, row)"

                (contextmenu)="onRowContextMenu($event, row)"

                (keydown)="onRowKeydown($event, row)"

                (mouseenter)="rowEnter.emit(row)"

                (mouseleave)="rowLeave.emit(row)"

              >

                <td

                  *ngFor="let col of columns; trackBy: trackColumn"

                  [class]="tdClass(col)"

                  [style.width.px]="manualColumnWidthPx(col)"

                  [style.min-width.px]="manualColumnWidthPx(col)"

                  [style.max-width.px]="manualColumnWidthPx(col)"

                  [attr.title]="cellTitle(col, row)"

                  (click)="col.cell === 'template' && col.stopRowClick ? $event.stopPropagation() : null"

                  (keydown.enter)="col.cell === 'template' && col.stopRowClick ? $event.stopPropagation() : null"

                  (keydown.space)="col.cell === 'template' && col.stopRowClick ? $event.stopPropagation() : null"

                >

                  <ng-container *ngIf="col.cell === 'template' && cellTemplate(col.id)">
                    <ng-container
                      *ngTemplateOutlet="cellTemplate(col.id)!.templateRef; context: { row: row }"
                    ></ng-container>
                  </ng-container>
                  <span
                    *ngIf="!(col.cell === 'template' && cellTemplate(col.id))"
                    class="tt-data-table__clip"
                    [class.tt-data-table__clip--wrap]="col.nowrap === false"
                  >{{ formatCell(col, row) }}</span>

                </td>

              </tr>

              <tr *ngIf="isRowExpanded(row)" class="tt-data-table__detail-row">
                <td [attr.colspan]="columns.length">
                  <ng-container
                    *ngTemplateOutlet="expandTemplate!.templateRef; context: { row: row }"
                  ></ng-container>
                </td>
              </tr>

            </ng-container>

          </tbody>

        </table>

      </div>

      <div
        #columnFilterPanel
        *ngIf="openFilterColumn as filterCol"
        class="tt-filter-overlay-panel tt-data-table__col-filter-panel fixed"
        [ngStyle]="filterPanelStyle"
        role="dialog"
        [attr.aria-label]="'Filtr: ' + filterCol.label"
        (mousedown)="onFilterPanelPointerDown($event)"
      >
        <div class="tt-filter-overlay-panel__title">{{ filterCol.label }}</div>
        <select
          *ngIf="columnFilterMode(filterCol) === 'select'; else colFilterTextPanel"
          class="tt-filter-control"
          [attr.aria-label]="'Filtrovat ' + filterCol.label"
          [value]="columnFilterValue(filterCol.id)"
          (change)="onColumnFilterInput(filterCol, $any($event.target).value)"
        >
          <option value="">Filtrovat…</option>
          <option *ngFor="let opt of columnFilterOptions(filterCol)" [value]="opt">{{ opt }}</option>
        </select>
        <ng-template #colFilterTextPanel>
          <input
            type="search"
            class="tt-filter-control"
            [attr.aria-label]="'Filtrovat ' + filterCol.label"
            [placeholder]="columnFilterPlaceholder(filterCol)"
            [value]="columnFilterValue(filterCol.id)"
            (input)="onColumnFilterInput(filterCol, $any($event.target).value)"
            (keydown.enter)="$event.preventDefault()"
            autocomplete="off"
            spellcheck="false"
          />
        </ng-template>
        <button
          *ngIf="isColumnFilterActive(filterCol)"
          type="button"
          class="mt-3 text-xs text-primary-600 dark:text-primary-400 hover:underline"
          (click)="clearColumnFilter(filterCol, $event)"
        >
          Zrušit filtr
        </button>
      </div>

    </div>



    <div class="tt-data-table__footer">

      <ng-content select="[dataTableFooter]"></ng-content>

    </div>

  </div>

</div>


